<div class="gw-ig-gallery-widget-header">
    <h2 class="gw-ig-gallery-widget-header__title">
        <slot />
    </h2>
</div>

<style>
    .gw-ig-gallery-widget-header {
        padding-top: var(--gw-ig-gallery-widget-header-pt);
        padding-bottom: var(--gw-ig-gallery-widget-header-pb);
    }
    .gw-ig-gallery-widget-header__title {
        font-size: var(--gw-ig-gallery-widget-header-fs);
        text-align: center;
    }
</style>
